module.exports = __webpack_public_path__ + "img/benefits-slider-4.1a348b44.png";